import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { VolumeBasemap, VolumeViewer3dComponent } from './volume-viewer-3d.component';

export interface VolumeViewerDialogData {
  coordinates: number[][];
  label?: string;
  title?: string;
  basemap?: VolumeBasemap;
}

/** Full-bleed MatDialog host for the 3D volume viewer. Open it via the static `open()`. */
@Component({
  selector: 'app-volume-viewer-dialog',
  standalone: true,
  imports: [VolumeViewer3dComponent],
  template: `
    <div class="volume-dialog">
      <app-volume-viewer-3d
        [coordinates]="data.coordinates"
        [volumeLabel]="data.label || ''"
        [basemap]="data.basemap || 'satellite'"
        [overlay]="true"
        (closed)="dialogRef.close()"
      />
      @if (data.title) {
        <div class="volume-dialog__title">{{ data.title }}</div>
      }
    </div>
  `,
  styles: [`
    :host { display: block; width: 100%; height: 100%; }
    .volume-dialog { position: relative; width: 100%; height: 100%; }
    .volume-dialog__title {
      position: absolute; left: 40px; bottom: 40px; max-width: calc(100% - 80px);
      height: 32px; line-height: 30px; padding: 0 12px; box-sizing: border-box;
      border: 1px solid #e9ecf4; border-radius: 16px; background: #fff;
      box-shadow: 2px 4px 12px 0 #c3c7d5; color: #060b1e;
      font-family: Montserrat, sans-serif; font-size: 12px; font-weight: 600;
      white-space: nowrap; overflow: hidden; text-overflow: ellipsis; pointer-events: none;
    }
  `],
})
export class VolumeViewerDialogComponent {
  static open(dialog: MatDialog, data: VolumeViewerDialogData): MatDialogRef<VolumeViewerDialogComponent> {
    return dialog.open(VolumeViewerDialogComponent, {
      data,
      width: '100vw',
      maxWidth: '100vw',
      height: '100vh',
      maxHeight: '100vh',
      panelClass: 'volume-viewer-dialog-panel',
      backdropClass: 'volume-viewer-dialog-backdrop',
      autoFocus: false,
    });
  }

  readonly dialogRef = inject<MatDialogRef<VolumeViewerDialogComponent>>(MatDialogRef);
  readonly data = inject<VolumeViewerDialogData>(MAT_DIALOG_DATA);
}
